module.exports = __webpack_public_path__ + "static/media/gif.6c8e0322.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/gif.gif
// module id = 669
// module chunks = 0